module.exports = "<div class=\"<%= gwBadge %> {{styles['gwBadge_type_' + (type || 'default')]}} {{styles['gwBadge_flavor_' + (flavor || 'default')]}}\">\r\n    <div class=\"<%= gwBadge__content %>\">\r\n        <ng-transclude></ng-transclude>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/platform/widgets/badge/BadgeDirective.html
// module id = 903
// module chunks = 0